import { takeLatest, takeEvery } from 'redux-saga/effects';
import { REFERENCE_INFORMATION_MODULE } from '../../../configs/moduleNames';
import {
  CHECK_EXISTING_ACTUAL_TEMPLATE,
  CREATE_NOTIFICATION_TEMPLATE,
  CREATE_REGISTRY_OF_SUSPENSION_REASONS,
  DELETE_REGISTRY_OF_SUSPENSION_REASONS_BY_ID,
  EDIT_NOTIFICATION_TEMPLATE_BY_ID,
  EDIT_REGISTRY_OF_SUSPENSION_REASONS_BY_ID,
  EXPORT_USER_ACTION_LOG,
  LOAD_NOTIFICATION_TEMPLATE_BY_ID,
  LOAD_OF_INSURANCE_COMPANIES_LIST,
  LOAD_OF_NOTIFICATION_TEMPLATE_REGISTRY_LIST,
  LOAD_REASON_LIST, LOAD_REASON_LIST_ALL,
  LOAD_REGISTER_OF_SUSPENSION_RESPONSE_LIST,
  LOAD_REGISTRY_OF_SUSPENSION_REASONS_BY_ID,
  LOAD_TEMPLATE_HELPER_DATA,
  LOAD_USER_ACTION_BY_ID,
  LOAD_USER_ACTION_LIST,
} from '../actions';

import loadUserActionLogList from './loadUserActionLogList';
import loadNotificationTemplateRegistryList from './loadNotificationTemplateRegistryList';
import exportUserActionLog from './exportUserActionLog';
import loadRegistryOfSuspensionReasonsList from './loadRegistryOfSuspensionReasonsList';
import loadInsuranceCompaniesList from './loadInsuranceCompaniesList';
import loadReasonList from './loadReasonList';
import editNotificationTemplateById from './editNotificationTemplateById';
import createNotificationTemplate from './createNotificationTemplate';
import deleteRegistryOfSuspensionReasonsById from './deleteRegistryOfSuspensionReasonsById';
import loadNotificationTemplateById from './loadNotificationTemplateById';
import createRegistryOfSuspensionReasons from './createRegistryOfSuspensionReasons';
import editRegistryOfSuspensionReasonsById from './editRegistryOfSuspensionReasonsById';
import loadRegistryOfSuspensionReasonsById from './loadRegistryOfSuspensionReasonsById';
import loadUserActivityLogsById from './loadUserActivityLogsById';
import loadTemplateHelperData from './loadTemplateHelperData';
import loadReasonListAll from './loadReasonListAll';
import checkExistingActualTemplate from './checkExistingActualTemplate';

export default function* watchDashboard() {
  yield takeLatest(REFERENCE_INFORMATION_MODULE + LOAD_USER_ACTION_LIST, loadUserActionLogList);
  yield takeLatest(REFERENCE_INFORMATION_MODULE + LOAD_USER_ACTION_BY_ID, loadUserActivityLogsById);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + LOAD_OF_INSURANCE_COMPANIES_LIST, loadInsuranceCompaniesList);
  yield takeLatest(REFERENCE_INFORMATION_MODULE + LOAD_REGISTER_OF_SUSPENSION_RESPONSE_LIST, loadRegistryOfSuspensionReasonsList);
  yield takeLatest(REFERENCE_INFORMATION_MODULE + LOAD_OF_NOTIFICATION_TEMPLATE_REGISTRY_LIST, loadNotificationTemplateRegistryList);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + EXPORT_USER_ACTION_LOG, exportUserActionLog);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + LOAD_REASON_LIST, loadReasonList);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + LOAD_REASON_LIST_ALL, loadReasonListAll);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + CREATE_NOTIFICATION_TEMPLATE, createNotificationTemplate);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + EDIT_NOTIFICATION_TEMPLATE_BY_ID, editNotificationTemplateById);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + LOAD_NOTIFICATION_TEMPLATE_BY_ID, loadNotificationTemplateById);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + DELETE_REGISTRY_OF_SUSPENSION_REASONS_BY_ID, deleteRegistryOfSuspensionReasonsById);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + CREATE_REGISTRY_OF_SUSPENSION_REASONS, createRegistryOfSuspensionReasons);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + EDIT_REGISTRY_OF_SUSPENSION_REASONS_BY_ID, editRegistryOfSuspensionReasonsById);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + LOAD_REGISTRY_OF_SUSPENSION_REASONS_BY_ID, loadRegistryOfSuspensionReasonsById);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + LOAD_TEMPLATE_HELPER_DATA, loadTemplateHelperData);
  yield takeEvery(REFERENCE_INFORMATION_MODULE + CHECK_EXISTING_ACTUAL_TEMPLATE, checkExistingActualTemplate);
}
